var skanGym = skanGym || {};

$(function () {
	skanGym.modal.teacherModal();
});

skanGym.modal = new function () {
	this.teacherModal = function () {
		$('.teacher-item').click(function(){
			var $button = $(this),
			modal = $('#modal-teacher'),
			modalContent = $button.attr('data-modal-content');

			// Set content of the modal
			modal.find('.modal-content').html($(modalContent).html());
			// Fire modal
			modal.modal('show');
		});
	}
}